export const filterKeysFromObj = (obj, ...keys) => {
    return Object.entries(obj).reduce((acc, [key, val]) => {
        if (keys.includes(key)) return acc;
        acc[key] = val;
        return acc;
    }, {});
};